import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ActionType, TextKey } from '@mews-commander/enums';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { IconName } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { getReservationGroupName } from '@mews-commander/legacy-entities/src/ducks/reservationGroups';
import { HeadingAction } from '../../../legacy/React/Components/HeadingAction/Action/types';
import { useCloseButton } from '../../../core/windowManager/hooks';
import ModalHeader from '../../../legacy/React/Components/Common/ModalHeader';
import { changeDocumentTitle } from '../../../middleware';

export const GroupBillingHeader = ({ groupId, guideLink }: { groupId: string; guideLink: string }) => {
    const dispatch: CommanderThunkDispatch = useDispatch();
    const closeButton = useCloseButton();
    const groupName = useSelector((state: ApplicationState) => getReservationGroupName(state, { id: groupId }));

    useEffect(() => {
        if (groupName) dispatch(changeDocumentTitle(groupName));
    }, [dispatch, groupName]);

    const actions: HeadingAction[] = [
        {
            url: guideLink,
            target: '_blank',
            icon: IconName.Help,
            text: <LocalizedText textKey={TextKey.Help} />,
            type: ActionType.Link,
        },
    ];

    return <ModalHeader title={groupName} actions={actions} primaryAction={closeButton} />;
};
